import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { ImageUtil } from "../../../utils"; // Ensure correct import
import PrevButtonComponent from "../button/PrevButtonComponent";
import EditButtonComponent from "../button/EditButtonComponent";
import DeleteButtonComponent from "../button/DeleteButtonComponent";
import UpdateButtonComponent from "../button/UpdateButtonComponent";
import IconComponent from '../button/IconComponent'
import InputCheckboxComponent from "../input/InputCheckboxComponent";

// ✅ Utility Function to Extract Nested Values Safely
const getNestedValue = (obj, key) => {
    return key.split('.').reduce((acc, part) => acc && acc[part], obj) || "-";
};

const TableColumnsComponent = ({
    tableData,
    handleClickPrevAction,
    handleClickEditAction,
    handleClickUpdateAction,
    handleClickDeleteAction,
    handleClickAddFormColumnAction,
    handleClickAddFormSectionAction,
    handleClickAddFormFieldAction,
    handleClickActiveAction,
    handleClickOnDayAction,
    handleClickOnDayAvailabilityAction,
    handleClickInIPAction,
}) => {
    const columns = useMemo(() => {
        if (!tableData || tableData.length === 0) return [];

        return tableData.map((item) => {
            if (item.options_type === "image") {
                return {
                    name: item.name,
                    label: item.label,
                    options: {
                        display: item?.display ?? true,  // Default to true only if undefined or null
                        sort: item?.sort ?? false,
                        download: item?.download ?? false,
                        filter: item?.filter ?? false,
                        print: item?.print ?? false,
                        searchable: item?.searchable ?? false,
                        customBodyRender: (value, tableMeta) => {
                            return (
                                <div className="table-image-box">
                                    <span className="avatar-img">
                                        <img src={value || ImageUtil.userAvatar} alt={item.label} loading="lazy" width="40" height="40" />
                                    </span>
                                </div>
                            );
                        },
                    },
                };
            }

            if (item.options_type === "normal") {
                return {
                    name: item.name,
                    label: item.label,
                    options: {
                        display: item?.display ?? true,  // Default to true only if undefined or null
                        sort: item?.sort ?? false,
                        download: item?.download ?? false,
                        filter: item?.filter ?? false,
                        print: item?.print ?? false,
                        searchable: item?.searchable ?? false,
                    },
                };
            }

            if (item.options_type === "icon") {
                return {
                    name: item.name,
                    label: item.label,
                    options: {
                        display: item?.display ?? true,  // Default to true only if undefined or null
                        sort: item?.sort ?? false,
                        download: item?.download ?? false,
                        filter: item?.filter ?? false,
                        print: item?.print ?? false,
                        searchable: item?.searchable ?? false,
                        customBodyRender: (value, tableMeta) => {
                            return (
                                <div className="table-image-box">
                                    <IconComponent icon={value} height={28} color="blue" />
                                </div>
                            );
                        },
                    },
                };
            }

            if (item.options_type === "boolean") {
                return {
                    name: item.name,
                    label: item.label,
                    options: {
                        display: item?.display ?? true,  // Default to true only if undefined or null
                        sort: item?.sort ?? false,
                        download: item?.download ?? false,
                        filter: item?.filter ?? false,
                        print: item?.print ?? false,
                        searchable: item?.searchable ?? false,
                        customBodyRender: (value, tableMeta) => {
                            return (
                                <div className="table-image-box">
                                    <IconComponent icon={value ? "icon-park:correct" : "qlementine-icons:wireless-none-16"} height={24} color="blue" />
                                </div>
                            );
                        },
                    },
                };
            }

            if (item.options_type === "actions") {
                return {
                    name: item.name,
                    label: item.label,
                    options: {
                        display: item?.display ?? true,  // Default to true only if undefined or null
                        sort: item?.sort ?? false,
                        download: item?.download ?? false,
                        filter: item?.filter ?? false,
                        print: item?.print ?? false,
                        searchable: item?.searchable ?? false,
                        setCellProps: () => ({
                            style: {
                                width: '170px', // or any width you prefer
                                minWidth: '170px',
                                maxWidth: '170px',
                                textAlign: 'center',
                            },
                        }),
                        customBodyRender: (value, tableMeta) => {
                            return (
                                <div className="row justify-content-md-center">
                                    {handleClickPrevAction && <PrevButtonComponent onClick={() => handleClickPrevAction(value)} />}
                                    {handleClickEditAction && <EditButtonComponent onClick={() => handleClickEditAction(value)} />}
                                    {handleClickUpdateAction && <UpdateButtonComponent onClick={() => handleClickUpdateAction(value)} />}
                                    {handleClickDeleteAction && <DeleteButtonComponent onClick={() => handleClickDeleteAction(value)} />}
                                </div>
                            );
                        },
                    },
                };
            }

            if (item.options_type === "form_column_actions") {
                return {
                    name: item.name,
                    label: item.label,
                    options: {
                        display: item?.display ?? true,  // Default to true only if undefined or null
                        sort: item?.sort ?? false,
                        download: item?.download ?? false,
                        filter: item?.filter ?? false,
                        print: item?.print ?? false,
                        searchable: item?.searchable ?? false,
                        customBodyRender: (value, tableMeta) => {
                            return (
                                <div className="row justify-content-md-center">
                                    {handleClickAddFormColumnAction && <PrevButtonComponent onClick={() => handleClickAddFormColumnAction(value)} />}

                                </div>
                            );
                        },
                    },
                };
            }
            if (item.options_type === "form_section_actions") {
                return {
                    name: item.name,
                    label: item.label,
                    options: {
                        display: item?.display ?? true,  // Default to true only if undefined or null
                        sort: item?.sort ?? false,
                        download: item?.download ?? false,
                        filter: item?.filter ?? false,
                        print: item?.print ?? false,
                        searchable: item?.searchable ?? false,
                        customBodyRender: (value, tableMeta) => {
                            return (
                                <div className="row justify-content-md-center">
                                    {handleClickAddFormSectionAction && <PrevButtonComponent onClick={() => handleClickAddFormSectionAction(value)} />}
                                </div>
                            );
                        },
                    },
                };
            }
            if (item.options_type === "form_field_actions") {
                return {
                    name: item.name,
                    label: item.label,
                    options: {
                        display: item?.display ?? true,  // Default to true only if undefined or null
                        sort: item?.sort ?? false,
                        download: item?.download ?? false,
                        filter: item?.filter ?? false,
                        print: item?.print ?? false,
                        searchable: item?.searchable ?? false,
                        customBodyRender: (value, tableMeta) => {
                            return (
                                <div className="row justify-content-md-center">
                                    {handleClickAddFormFieldAction && <PrevButtonComponent onClick={() => handleClickAddFormFieldAction(value)} />}
                                </div>
                            );
                        },
                    },
                };
            }

            if (item.options_type === "active") {
                return {
                    name: item.name,
                    label: item.label,
                    options: {
                        display: item?.display ?? true,  // Default to true only if undefined or null
                        sort: item?.sort ?? false,
                        download: item?.download ?? false,
                        filter: item?.filter ?? false,
                        print: item?.print ?? false,
                        searchable: item?.searchable ?? false,
                        customBodyRender: (value, tableMeta) => {
                            let id = tableMeta.rowData[0];
                            return (
                                <div className="row justify-content-md-center">
                                    <InputCheckboxComponent
                                        style="form-check-input mr-2"
                                        label={value ? "Yes" : "No"}
                                        type="checkbox"
                                        name="active-me"
                                        checked={value}
                                        onChange={() => handleClickActiveAction(id, value)}
                                        display=""
                                        disabled={false}
                                    />
                                </div>
                            );
                        },
                    },
                };
            }

            if (item.options_type === "onDayAction") {
                return {
                    name: item.name,
                    label: item.label,
                    options: {
                        display: item?.display ?? true,  // Default to true only if undefined or null
                        sort: item?.sort ?? false,
                        download: item?.download ?? false,
                        filter: item?.filter ?? false,
                        print: item?.print ?? false,
                        searchable: item?.searchable ?? false,
                        customBodyRender: (value, tableMeta) => {
                            let id = tableMeta.rowData[0];
                            return (
                                <div className="row justify-content-md-center">
                                    <InputCheckboxComponent
                                        style="form-check-input mr-2"
                                        label={value ? "Yes" : "No"}
                                        type="checkbox"
                                        name="active-me"
                                        checked={value}
                                        onChange={() => handleClickOnDayAction(id, value)}
                                        display=""
                                        disabled={false}
                                    />
                                </div>
                            );
                        },
                    },
                };
            }

            if (item.options_type === "onDayAvailabilityAction") {
                return {
                    name: item.name,
                    label: item.label,
                    options: {
                        display: item?.display ?? true,  // Default to true only if undefined or null
                        sort: item?.sort ?? false,
                        download: item?.download ?? false,
                        filter: item?.filter ?? false,
                        print: item?.print ?? false,
                        searchable: item?.searchable ?? false,
                        customBodyRender: (value, tableMeta) => {
                            let id = tableMeta.rowData[0];
                            return (
                                <div className="row justify-content-md-center">
                                    <InputCheckboxComponent
                                        style="form-check-input mr-2"
                                        label={value ? "Yes" : "No"}
                                        type="checkbox"
                                        name="active-me"
                                        checked={value}
                                        onChange={() => handleClickOnDayAvailabilityAction(id, value)}
                                        display=""
                                        disabled={false}
                                    />
                                </div>
                            );
                        },
                    },
                };
            }

            if (item.options_type === "inip") {
                return {
                    name: item.name,
                    label: item.label,
                    options: {
                        display: item?.display ?? true,  // Default to true only if undefined or null
                        sort: item?.sort ?? false,
                        download: item?.download ?? false,
                        filter: item?.filter ?? false,
                        print: item?.print ?? false,
                        searchable: item?.searchable ?? false,
                        customBodyRender: (value, tableMeta) => {
                            let id = tableMeta.rowData[0];
                            return (
                                <div className="row justify-content-md-center">
                                    <InputCheckboxComponent
                                        style="form-check-input mr-2"
                                        label={value ? "Yes" : "No"}
                                        type="checkbox"
                                        name="inip-me"
                                        checked={value}
                                        onChange={() => handleClickInIPAction(id, value)}
                                        display=""
                                        disabled={false}
                                    />
                                </div>
                            );
                        },
                    },
                };
            }

            return null; // Skip invalid types
        }).filter(Boolean); // Remove null values
    }, [tableData, handleClickPrevAction, handleClickEditAction, handleClickDeleteAction]);

    return columns;
};

// ✅ Define PropTypes
TableColumnsComponent.propTypes = {
    handleClickPrevAction: PropTypes.func,
    handleClickEditAction: PropTypes.func,
    handleClickUpdateAction: PropTypes.func,
    handleClickDeleteAction: PropTypes.func,
    handleClickAddFormColumnAction: PropTypes.func,
    handleClickAddFormSectionAction: PropTypes.func,
    handleClickAddFormFieldAction: PropTypes.func,
    handleClickActiveAction: PropTypes.func,
    handleClickOnDayAction: PropTypes.func,
    handleClickOnDayAvailabilityAction: PropTypes.func,
    handleClickInIPAction: PropTypes.func,
    tableData: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            options_type: PropTypes.oneOf(["image", "normal", "actions"]).isRequired,
        })
    ).isRequired,
};

export default TableColumnsComponent;
